import { ContentTag, provideComponent, useData } from "scrivito"

import { DataFormInputFieldWidget } from "./DataFormInputFieldWidgetClass"

provideComponent(DataFormInputFieldWidget, ({ widget }) => {
  const attributeName = useData().attributeName()
  const id = ["DataFormInputFieldWidget", widget.id(), attributeName].join("-")

  const value = useData().dataItemAttribute()?.get()
  const defaultValue = value ? value.toString() : ""

  return (
    <div className="scrivito-form__input-container input mb-3" key={id}>
      <ContentTag
        content={widget}
        attribute="label"
        tag="label"
        className="label input__label"
        htmlFor={id}
      />

      {widget.get("type") === "multi_line" ? (
        <textarea
          className="form-control"
          id={id}
          name={attributeName ?? ""}
          rows={3}
          defaultValue={defaultValue}
          placeholder={widget.get("placeholder")}
          required={widget.get("required")}
        />
      ) : (
        <div className="input__control input__focus">
          <input
            id={id}
            name={attributeName ?? ""}
            defaultValue={defaultValue}
            maxLength={widget.get("maxLength") || 250}
            placeholder={widget.get("placeholder")}
            type={calculateType(widget.get("type"))}
            required={widget.get("required")}
          />
        </div>
      )}
    </div>
  )
})

function calculateType(type: string | null): string {
  if (type === "email") return "email"
  if (type === "phone_number") return "tel"

  return "text"
}
